import EntityTitle from '@/entity/components/EntityTitle'
import ExecutionLineChart from '@/pollution/components/ExecutionLineChart'
import ExecutionDetail from '@/pollution/components/ExecutionDetail'
import {entityOaid} from '../../util/util'

let pollutant_emission = {
  components: {EntityTitle, ExecutionLineChart, ExecutionDetail},
  // props: ['oaid'],
  data: () => {
    return {
      oaid: null
    }
  },
  methods: {
    changeOaid () {
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid = result
      })
    }
  },
  mounted () {
    this.changeOaid()
  }
}
export default pollutant_emission



// WEBPACK FOOTER //
// ./src/pollution/js/pollutant_emission.js